export default {
  courierInfo(state) {
    return state.courier;
  },
};
